<script lang="ts">
    import { Button, Nav, NavItem, NavLink } from "sveltestrap";
    import { Dashboard, Dropdownexample, Footers, General, Layout, LogOut, PageLayout, Sidebar, Widgets } from "../../../utils/Constant/Constant";
    import FeatherIcon from "svelte-feather-icon";
</script>
<div class="onhover-dropdown navs-dropdown">
    <Button class="onhover-dropdown" color="primary">{Dropdownexample} <i class="icon-arrow-down"></i></Button>
    <div class="onhover-show-div">
        <Nav class="icon-lists border navs-icon" vertical>
            <NavItem>
                <h5 class="mb-0">{General}</h5>
            </NavItem>
            <NavItem>
                <NavLink>
                    <FeatherIcon icon="home" />
                    <span>{Dashboard}</span>
                </NavLink>
            </NavItem>
            <NavItem class="pb-0">
                <NavLink>
                    <FeatherIcon icon="airplay" />
                    <span>{Widgets}</span>
                </NavLink>
            </NavItem>
            <NavItem class="main-section">
                <NavLink>
                    <h5 class="mb-0">{Layout}</h5>
                </NavLink>
            </NavItem>
            <NavItem class="pb-0">
                <NavLink>
                    <FeatherIcon icon="sidebar" />
                    <span> {Sidebar}</span>
                </NavLink>
            </NavItem>
            <NavItem>
                <NavLink>
                    <FeatherIcon icon="layout" />
                    <span>{PageLayout}</span>
                </NavLink>
            </NavItem>
            <NavItem class="pt-0">
                <NavLink>
                    <FeatherIcon icon="cloud-lightning" />
                    <span> {Footers}</span>
                </NavLink>
            </NavItem>
            <NavItem class="separator"></NavItem>
            <NavItem class="pt-0">
              <Button outline  class="btn-pill" color="primary">{LogOut}</Button>
            </NavItem>
        </Nav>
    </div>
</div>